import MainSlider from '@components/MainSlider/MainSlider';

(function () {
  'use strict';
  const newsPostContent = document.querySelector('.news-post-content');
  if (!newsPostContent) return;

  const content = newsPostContent.innerHTML;

  const regex = /{{\s*([^}]+)\s*}}/g;

  const result = content.replace(regex, (match, matchKeyValue) => {
    const keys = matchKeyValue.split(/\s+/);
    const keyValueFormatted = {};

    keys.forEach(key => {
      const [keyName, keyValue] = key.split('=');
      keyValueFormatted[keyName] = keyValue;
    });

    if (!keyValueFormatted.banner_id && !keyValueFormatted.banner_id) {
      console.error('Chave de template não esperada.');
      return '';
    }

    const idDesktop = keyValueFormatted.banner_id;
    const idMobile = keyValueFormatted.banner_id_mobile || idDesktop;

    return `<div data-vue=banner-dynamic><main-slider id-mobile="${idDesktop}" id-desktop="${idMobile}"></main-slider></div>`;
  });

  newsPostContent.innerHTML = result;

  document.querySelectorAll('[data-vue=banner-dynamic]').forEach((el, index) => {
    new Vue({
      el: el,
      components: {
        MainSlider
      }
    })
  });
})();
